import React from 'react'

import { Alert } from '@mui/material'
import Container from './styles'

function BuildScoreData({ score_data }) {
  const score = score_data?.quod_score
  const issue_summary = score_data?.issue_summary

  const HIGH_SCORE_THRESHOLD = 600
  const isHighScore = (score || 0) >= 600
  const text =
    score == null
      ? 'A análise de Pendências Financeiras foi solicitada.'
      : isHighScore
      ? `Score maior que ${HIGH_SCORE_THRESHOLD} pontos. As Pendências Financeiras não serão analisadas`
      : `Score menor que  ${HIGH_SCORE_THRESHOLD} pontos. A análise de Pendências Financeiras foi solicitada.`
  return (
      <Container>
        {score != null && <React.Fragment>
          <span>Pontuação: </span>
          {score}
          <br /> <br />
        </React.Fragment> }

        {score == null &&
          <Alert severity='warning' style={{ marginBottom: 10 }}> 
            {issue_summary || 'Não foi possível obter o Score QUOD.' }
            
          </Alert>
        }

        <p>{text}</p>
      </Container>
  )
}

export default BuildScoreData
